import { useMutation } from '@tanstack/react-query';

import { ExportStatistiquesViolationsDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { ExportStatistiquesFormValues } from 'pages/admin-fonctionnel/AdministrationAvancee/ExportStatistiques/types';

export function useValidateExportStatistiquesForm() {
  const { AdminFonctionnelControllerApi: controller } = useApi();

  const mutation = useMutation({
    mutationFn: async ({
      field,
      changedValues,
    }: {
      field: ExportStatistiquesViolationsDtoFormFieldEnum;
      changedValues: ExportStatistiquesFormValues;
    }) => {
      const violations =
        await controller.validationExportStatistiquesFieldUsingPOST(field, {
          dateDebut: changedValues.dateDebut || null,
          dateFin: changedValues.dateFin || null,
        });
      if (violations.length === 0) {
        return Promise.resolve();
      }
      return Promise.reject(violations[0].message);
    },
  });

  return (
    field: ExportStatistiquesViolationsDtoFormFieldEnum,
    changedValues: ExportStatistiquesFormValues,
  ): Promise<void> => mutation.mutateAsync({ field, changedValues });
}
